import { ParsedQuery } from 'query-string';
import { useCallback } from 'react';
import { Transformer as HashTransformer, useHash } from 'hooks/use-hash';
import { TaskDrawerTab } from 'hooks/use-navigate-to-task';

type Show = ['show', TaskDrawerTab];
export type TaskDrawerTabParams = Show;

const taskDrawerTabTransformer: HashTransformer<TaskDrawerTabParams> = {
  from: (parsed) => {
    const tab = parsed.task_drawer_tab as TaskDrawerTab | undefined;

    switch (tab) {
      case TaskDrawerTab.Approvals:
        return ['show', TaskDrawerTab.Approvals];
      case TaskDrawerTab.Conversations:
      default:
        return ['show', TaskDrawerTab.Conversations];
    }
  },
  to: (params): ParsedQuery => {
    switch (params[0]) {
      case 'show':
        return {
          task_drawer_tab: params[1],
        };
      default:
        return { task_drawer_tab: null };
    }
  },
};

type ShowFunction = (tab: TaskDrawerTab) => void;

export const useTaskDrawerTab = (): [TaskDrawerTabParams, ShowFunction] => {
  const [params, setParams] = useHash(taskDrawerTabTransformer);
  const show = useCallback(
    (tab: TaskDrawerTab) => {
      setParams(['show', tab]);
    },
    [setParams],
  );

  return [params, show];
};
